// extracted by mini-css-extract-plugin
export default {"container":"brands-list_container__1KZu7"};